module.exports = __webpack_public_path__ + "img/KP.c6737984.png";